import React from "react";
import { Routes, Route, Navigate } from "react-router-dom";
import Home from "../pages/home/home.js";
import Walkin from "../pages/walkin/walkin";
import Disclaimer from "../pages/disclaimer/disclaimer";
import SignOn from "../pages/signon/signon.js";
import PrivateRoute from "./PrivateRoute.js";
import PrivateRouteWalkin from "./PrivateRouteWalkin.js";
import NotFound from "../pages/error/NotFound.js";

export default function Routing() {
  return (
    <Routes>
      <Route path="/sign-in" element={<SignOn />} />
      {/* <Route path="/walkincenter" element={<Walkin />} /> */}
      <Route path="/disclaimer" element={<Disclaimer />} />
      {/* <Route path="/test" element={<Home />} />
      <Route path="/testwk" element={<Walkin />} /> */}

      <Route path="/">
        <Route index element={<Navigate to="/homepage" replace />} />
        <Route
          path="homepage"
          element={
            <PrivateRoute>
              <Home />
            </PrivateRoute>
          }
        />
        <Route
          path="walkincenter"
          element={
            <PrivateRouteWalkin>
              <Walkin />
            </PrivateRouteWalkin>
          }
        />
      </Route>

      <Route path="*" element={<NotFound />} />
    </Routes>
  );
}
